export const OnHoldFormBoxes = [
  {
    label: 'From Date',
    name: 'startDate',
    width: '226px',
    placeholder: 'mm/dd/yyyy',
    isMandatory: true,
    isDatePicker: true,
    height: '48px',
  },
  {
    label: 'To Date',
    name: 'endDate',
    width: '226px',
    placeholder: 'mm/dd/yyyy',
    isMandatory: true,
    isDatePicker: true,
    height: '48px',
  },
];

export const OnHoldColumns = [
  {
    Header: '#',
    accessor: 'lineNo',
    width: 30,
  },
  {
    Header: 'Name',
    accessor: 'name',
  },
  {
    Header: 'Type',
    accessor: 'type',
  },
  {
    Header: 'Date Placed On-Hold',
    accessor: 'datePlacedOnHold',
  },
  {
    Header: 'Date Removed from On-Hold',
    accessor: 'dateRemovedFromOnHold',
  },
];

export const ALL_ADDRESSES = 'All Addresses';

export const ADDRESS_EXTRA_OPTION = {
  id: ALL_ADDRESSES,
  value: ALL_ADDRESSES,
  label: ALL_ADDRESSES,
};

export const ALL_COMMUNITIES = 'All Communities';

export const COMMUNITIES_EXTRA_OPTION = {
  id: ALL_COMMUNITIES,
  value: ALL_COMMUNITIES,
  label: ALL_COMMUNITIES,
};

export const ALL_MANAGEMENTS = 'All Managements';

export const MANAGEMENT_EXTRA_OPTION = {
  id: ALL_MANAGEMENTS,
  value: ALL_MANAGEMENTS,
  label: ALL_MANAGEMENTS,
};
